import { getRegion, Region } from '../config/utils';

import usTranslations from './regions/us.json';
import euTranslations from './regions/eu.json';
import caTranslations from './regions/ca.json';
import auTranslations from './regions/au.json';

type TranslationKey = keyof typeof auTranslations &
  keyof typeof caTranslations &
  keyof typeof euTranslations &
  keyof typeof usTranslations;

const getRegionTranslations = (region: Region): typeof usTranslations => {
  switch (region) {
    case Region.EU:
      return euTranslations;
    case Region.CA:
      return caTranslations;
    case Region.AU:
      return auTranslations;
    case Region.US:
    default:
      return usTranslations;
  }
};

const region = getRegion();
const translations = getRegionTranslations(region);

export const regional = (key: TranslationKey): string => {
  return translations[key];
};
